import Env from "../env/Env";
import createAxiosInstance from "../utils/axiosInstance";
import { defaultAPIsResponseType, defaultGraphsGetFiltersType } from "../consts/shared";


const basePath = '/api/graphs/dashboard-6';
const request = createAxiosInstance(`${Env.API_BASE}${basePath}`);

const dashboard6APIsService = {
  basePath,
  fetchOrganisationWithUsersAndCreditDetailsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
      return new Promise((resolve, reject) => {
        request
          .get("/organisation-with-users-and-credit-details", { params, signal })
          .then(({ data }) => {
            resolve({ ...data, ...params });
          })
          .catch((err) => {
            reject(err?.response?.data?.errors || []);
          });
      });
    },
  fetchOrganisationsWithoutCreditsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/organisations-without-credits", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchPercentageOfCreditsUsedAvailableByOrganisationData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/percentage-of-credits-used-available-by-organisation", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchSummaryCardsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/summary-cards", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchCreditReportData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/credit-report", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
};

export default dashboard6APIsService;
